import React from 'react'
import {Context as AppContext} from '../../contexts/App'
import {Context as SalesChannelsContext} from '../../contexts/SalesChannels'

import Stack from '@mui/material/Stack'

import Paper from '@mui/material/Paper'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import IndianaScroller from 'react-indiana-drag-scroll'

import Table from '../../components/MUITable'
import money from '../../components/Money'

const ProductPublicityToolbar = (props) => {
  const { currentt } = props

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
      }}
    >
      <Typography
        sx={{ flex: '1 1 100%' }}
        variant="h6"
        id="tableTitle"
        component="div"
      >
        Costos de publicidad de productos
      </Typography>
      {currentt && 
        <React.Fragment>
          
        </React.Fragment>
      }
      
    </Toolbar>
  )
}

const ProductPublicity = () => {
  const { vendor,  } = React.useContext(AppContext)
  const SalesChannel = React.useContext(SalesChannelsContext)
  const { current } = SalesChannel
  const { productPublicities, detail } = SalesChannel.productPublicities
  const [selected, setSelected] = React.useState([])

  React.useEffect(() => {
    if(selected.length == 1)
      detail(productPublicities[selected[0]-1])
    else
      detail(null)
  }, [selected])

  return (
    <IndianaScroller>
    <Stack sx={{ width: '90vw', }} >
      <ProductPublicityToolbar  vendor={vendor} current={current}/>
      <Paper sx={{ padding: "30px",  height:'80vh', display: 'flex', flexDirection: 'column' }}>
        <Table
            model={selected}
            setmodel={setSelected}
            data={productPublicities || []}
            columns={[
              {flex: 1, headerName: "Canal", field: "vendor"},
              {flex: 1, headerName: "Fecha", field: "date"},
              {flex: 1, headerName: "asin", field: "asin"},
              {flex: 2, headerName: "sku", field: "sku"},
              {flex: 1, headerName: "Clicks", field: "clicks"},
              {flex: 1, headerName: "Órdenes", field: "orders"},
              {flex: 1, headerName: "Ventas", field: "sales",
                valueGetter: (value, row) => money.format(Number(row.sales)/100)
              },
              {flex: 1, headerName: "Inversión", field: "cost",
                valueGetter: (value, row) => money.format(Number(row.cost)/100)
              },
              {flex: 1, headerName: "ACOS estimado",
                valueGetter: (value, row) =>row.sales > 0?((Number(row.cost)/100)/(Number(row.sales)/100)*100).toFixed(2) : "N/A"
              },
            ]}
            options={{
              selection: true,
              pageSizes:[5, 10,25,50,100,250,500]
            }}
            sx={{
              '& .MuiDataGrid-cellContent': {
              overflow: 'scroll',
              textOverflow: 'unset',
              }
            }}
          />
      </Paper>
    </Stack>
    </IndianaScroller>
  )
}
export default ProductPublicity